/**
 * RatingDetailContainer
 * --
 */
import React from 'react';
import RatingDetailPresenter from './RatingDetailPresenter';

const RatingDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <RatingDetailPresenter />
    </>
  );
};

export default RatingDetailContainer;
